export const DEFAULT_CHECKLIST_MAX_QUESTIONS = 20;
export const MAX_CHECKLIST_QUESTIONS = 40;

export const resolveChecklistMaxQuestions = (value) => {
  if (value === undefined) return DEFAULT_CHECKLIST_MAX_QUESTIONS;
  if (!Number.isInteger(value) || value < DEFAULT_CHECKLIST_MAX_QUESTIONS || value > MAX_CHECKLIST_QUESTIONS) {
    throw new Error('Invalid inspection question limit. Reload the register settings.');
  }
  return value;
};

// Keep populated rows visible when an administrator lowers the allowance.
// Saving compacts blank rows only after the question count has been validated.
export const toChecklistQuestionRows = (questions = [], maxQuestions = DEFAULT_CHECKLIST_MAX_QUESTIONS) => {
  const source = Array.isArray(questions) ? questions : [];
  const lastQuestion = source.reduce((last, question, index) =>
    typeof question === 'string' && question.trim() ? index : last, -1);
  return Array.from({ length: Math.max(maxQuestions, lastQuestion + 1) },
    (_, index) => typeof source[index] === 'string' ? source[index] : '');
};

export const DEFAULT_CHECKLIST_QUESTIONS = [
  'Ex marking and EPL match the hazardous area zone?',
  'Equipment certificate number present and legible?',
  'Protection concept is correct for the application (Ex d/e/i/n/t/q/p)?',
  'Nameplate and circuit identification labels legible?',
  'Enclosure intact with no cracks or external damage?',
  'Cable glands are certified and of suitable type?',
  'Cable glands and cable entries intact, tight, and not visibly loose?',
  'Sealing washers and gaskets present and in good condition?',
  'IP integrity maintained (seals and gaskets intact)?',
  'Enclosure and mounting free from corrosion?',
  'No loose fixings, missing bolts, or damaged components?',
  'No visible unauthorized modifications?',
  'Temperature class on nameplate suitable for process conditions?',
  'No signs of overheating or discoloration on equipment surfaces?',
  'Cable sheaths undamaged and conduit/cable seals intact?',
  'Spare entries blanked with certified plugs?',
  'IS/non-IS separation and IS color coding visibly maintained?',
  'Equipment clean with no undue dust or dirt accumulation?',
  'Earth bonding present and properly connected?',
  'Mounting, clearances, and cable tray support/tie are acceptable?',
];
